import React, { Fragment, useEffect, useState } from "react";
import FadeIn from "react-fade-in/lib/FadeIn";
import {
  Button,
  Card,
  CardBody,
  Col,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  InputGroup,
  Label,
  Row,
  Table,
} from "reactstrap";
import ModalConID from "../ModalConID";
import { useInsertConText } from "../../Context/InsertContext";
import axios from "axios";
import { GetCookieToken } from "../../Cookie/GetCookie";
import { FetchAxiosPost, FetchAxiosPut } from "../../../api/axios";
import LoadingPage from "../../TESTPage/LoadingPage";
import SummaryTimeGroup from "../SummaryTimeGroup";
import MyThaiDatePick from "../../../components/Common/ThaiDatePicker";
import ConfirmModal from "../../../components/Common/ConfirmModal";
import { useLocation, useNavigate } from "react-router-dom";
import { CheckPosition } from "../../Function/CheckPosition";
import { CheckSubAdmin } from "../../Function/CheckSubAdmin";

const API_URL = process.env.REACT_APP_API_CORS;
function TimeCommander(props) {
  const {userInfo} = props
  const navigate = useNavigate();
  const [value_name_cont_1, setValue_name_cont_1] = useState("");
  const [user_start_work_name, setUserStartWorkName] = useState(null);
  const [user_start_work_id, setUserStartWorkId] = useState(null);
  const [startDate, setUserStartDate] = useState(null);
  const [chooseApprov, setChooseApprov] = useState([]);
  const [masterdata, setMasterdata] = useState([]);
  const [orgInnerID, setOrgInnerID] = useState(null);
  const [orgInnerName, setOrgInnerName] = useState(null);
  const [allarray, setAllarray] = useState(null);
  const [allarray2, setAllarray2] = useState(null);
  const [loading, setLoading] = useState(true);
  const { insert, setInsert, clearValue } = useInsertConText();
  const location = useLocation();
  const [userData, setUserData] = useState([]);

  const [confirmModal, setconfirmModal] = useState(false)

  const token = GetCookieToken("userToken");

  useEffect(() => {
    if (insert.task === "สำนัก/กอง/กลุ่ม") {
      setValue_name_cont_1(insert.insert_name);
      OrgFuctionName(insert.insert_id);
      setOrgInnerID(insert.insert_id);
      setOrgInnerName(insert.insert_name);
    }
  }, [insert]);

  const fetchDataOrgChild = async () => {
    const url = `${API_URL}/api/orgInner/level`;
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    await axios
      .get(url, config)
      .then((response) => {
        setAllarray(response.data.result);
        const allNodelv = []
        allNodelv.push(response.data.result)
        response.data.result.child.map((item, idx) => {
          allNodelv.push(item)
          item.child.map((subItem, subIdx) => {
            allNodelv.push(subItem)
            subItem.child.map((sublv3, idx3) => {
              allNodelv.push(sublv3)
            })
          })
        })
        const fillterActive = allNodelv.filter(x => x.active == 1)
        setAllarray2(fillterActive)
      })
      .catch((error) => console.error("Error:", error));
  };

  const OrgFuctionName = (id) => {
    const url = `${API_URL}/api/users/datatable`;
    const params = new URLSearchParams({
      page: 1,
      size: 1000,
      "order[0]": "user_name",
      "order[1]": "ASC",
      "filter[user_name_status][0]": "ปกติ",
      "filter[user_id_status][0]": "1",
      "filter[deleted][0]": "1",
      "filter[cont_to_id][0]": id,
    });
    const config = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: `Bearer ${token}`,
      },
      params,
    };
    axios
      .get(url, config)
      .then((response) => {
        response.data.result.map((i) => {
          fetchUserData(i.user_id);
        });

        setChooseApprov((prevChooseApprov) => [
          ...prevChooseApprov,
          ...response.data.result,
        ]);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const fetchUserData = (userid) => {
    const url = `${API_URL}/api/users/position/datatable`;
    const params = new URLSearchParams({
      page: 1,
      size: 10,
      "order[0]": "position_id",
      "order[1]": "DESC",
      "filter[assign][0]": "0",
      "filter[user_id][0]": userid,
      "filter[position_id][0]": 5,
      "filter[position_id][1]": 4,
      "filter[position_id][2]": 3,
      "filter[position_id][3]": 2,
    });
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params,
    };
    axios
      .get(url, config)
      .then((response) => {
        if (response.data.result.length !== 0) {
          const postionUserLevel = response.data.result.map((i) => i.user_id);
          setUserData((prev) => [...prev, Number(postionUserLevel)]);
        }
      })
      .catch((error) => console.error("Error:", error));
  };

  const fetchMasterData = async () => {
    try {
      const response = await axios.get(`${API_URL}/api/users/config/all`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setMasterdata(response.data.result);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    fetchMasterData();
    fetchDataOrgChild();
  }, []);

  const OrgFuctionTime = async (id) => {
    const url = `${API_URL}/api/users/${id}`;
    const params = new URLSearchParams({});
    const config = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: `Bearer ${token}`,
      },
      params,
    };
    await axios
      .get(url, config)
      .then(async (response) => {
        const url_user = `/api/users/${id}`;
        let data_user = {
          user_start_work_id: user_start_work_id,
          user_start_work_name: user_start_work_name,
          user_title_id: response.data.result.user_title_id,
          user_title_name: response.data.result.user_title_name,
          user_name: response.data.result.user_name,
          user_idcard: response.data.result.user_idcard,
          user_login: response.data.result.user_login,
        };
        if (isNaN(response.data.result.user_idcard) || response.data.result.user_idcard === "") {
          data_user.user_idcard = ""
        }
        await FetchAxiosPut(url_user, data_user, token);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const handleSubmit = () => {
    setLoading(true);

    const uniqueDataSet = [...new Set(userData)];
    const filteredData = chooseApprov.filter(
      (user) => !uniqueDataSet.includes(user.user_id)
    );
    filteredData.forEach(userID => {
      const url_userTime = "/api/usersTime/save";
        let data = {
          user_id: userID.user_id,
          user_start_work_id: user_start_work_id,
          user_start_work_name: user_start_work_name,
          start_date: startDate,
          status: "1",
        };
        OrgFuctionTime(userID.user_id);
        FetchAxiosPost(url_userTime, data, token);
    });

    setTimeout(() => {
      setLoading(false);
    }, 2000);
  };

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 1500);
  }, []);

  useEffect(() => {
    // allarray &&
    //   allarray.child.map((item, idx) => {
    //     if (orgInnerID == 1 ) {
    //         if (item.child.length > 0) {
    //           item.child.map((x) => {
    //             if (x.active === 1) {
    //               if (x.child.length > 0) {
    //                 x.child.map((y) => {
    //                   if (y.active === 1) {
    //                     OrgFuctionName(y.org_id);
    //                       if (y.child.length > 0) {
    //                           y.child.map((z) => {
    //                             if (z.active === 1) {
    //                               OrgFuctionName(z.org_id);
    //                             }
    //                           });
    //                       } else {
    //                         OrgFuctionName(y.org_id);
    //                       }
    //                   }
    //                 });
    //               } else {
    //                 OrgFuctionName(x.org_id);
    //               }
    //             }
    //         });
    //       } 
    //     } else if (item.org_id === orgInnerID) {
    //         if (item.child.length > 0) {
    //             item.child.map((x) => {
    //               if (x.active === 1) {
    //                 if (x.child.length > 0) {
    //                   x.child.map((y) => {
    //                     if (y.active === 1) {
    //                       OrgFuctionName(y.org_id);
    //                     }
    //                   });
    //                 } else {
    //                   OrgFuctionName(x.org_id);
    //                 }
    //               }
    //           });
    //         } else {
    //           OrgFuctionName(item.org_id);
    //         }
    //     }
    //   });


      if (allarray2?.filter(or => or.org_id == orgInnerID).length > 0) {
        let arr1 = allarray2?.filter(or => or.org_id == orgInnerID)[0]
        let arr2 = allarray2?.filter(or => or.parent_id == orgInnerID)
        arr2.map((item) => {
            if (item.child.length > 0) {
                item.child.map(lv3 => {
                  if (lv3.active == 1) {
                    OrgFuctionName(lv3.org_id)
                  }
                })
                  OrgFuctionName(item.org_id)
            } else {
                OrgFuctionName(item.org_id)
            } 
        })
        OrgFuctionName(arr1.org_id)
      } 

  }, [allarray, orgInnerID]);

  useEffect(() => {
    if (userInfo) {
      if (
        !CheckPosition(userInfo?.position) &&
        !CheckSubAdmin(userInfo?.positionSubAdmin)
      ) 
      {
        navigate("/setdata");
      }
    }
  }, [userInfo]);

  useEffect(() => {
    clearValue();
  }, [location.pathname, clearValue]);
  
  return (
    <Fragment>
      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "400px",
          }}
        >
          <LoadingPage />
        </div>
      ) : (
        <FadeIn>
          <ConfirmModal
            modal = {confirmModal}
            modalSize = "md"
            modalHeaderContent = "คุณต้องการที่จะบันทึก ใช่หรือไม่?"
            onClickConfirmBtn={() => {
              handleSubmit()
              setconfirmModal(false)
            }}
            onClickCancelBtn={() => {
              setconfirmModal(false)
            }}
          />
          <Card>
            <CardBody>
              <Form
                onSubmit={(e) => {
                  e.preventDefault();
                  setconfirmModal(true)
                }}
              >
                <Row>
                  <Col lg={12}>
                    <FormGroup>
                      <Label>สำนัก/กอง/กลุ่ม</Label>
                      <InputGroup>
                        <Input
                          value={value_name_cont_1}
                          name="cont_to"
                          placeholder="กรุณาใส่..."
                          type="text"
                        />

                        <ModalConID
                          user_id={null}
                          task="สำนัก/กอง/กลุ่ม"
                          taskFilter="ฟิลเตอร์กลุ่ม"
                        />
                      </InputGroup>
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col lg={12}>
                    <FormGroup>
                      <Label>กลุ่มเวลาเข้างาน</Label>

                      <Table>
                        <thead>
                          <tr>
                            <th>รอบเวลาเข้างาน</th>
                            <th>วันที่</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td className="w-50">
                              <Input
                                required
                                name="user_start_work_id"
                                className="custom-select"
                                type="select"
                                invalid={!user_start_work_id}
                                onChange={(e) => {
                                  setUserStartWorkName(
                                    e.target.options[e.target.selectedIndex]
                                      .text
                                  );
                                  setUserStartWorkId(e.target.value);
                                }}
                              >
                                <option>กรุณาเลือก</option>
                                {masterdata.user_start_work?.map(
                                  (masterdata, index) => (
                                    <option
                                      value={masterdata.user_start_work_id}
                                      key={index}
                                    >
                                      {masterdata.user_start_work_name}
                                    </option>
                                  )
                                )}
                              </Input>
                              {!user_start_work_id && (
                                <FormFeedback>โปรดเลือกกลุ่มเวลา</FormFeedback>
                              )}
                            </td>
                            <td>
                              <MyThaiDatePick placeholderText = "เลือกวันที่..." setProbsDate = {setUserStartDate} invalidProps = {!startDate} requireProps = {true}/>
                              {!startDate ? <div className="text-danger py-1" style={{fontSize: '10px' }}>โปรดเลือกวันที่</div> : ""}
                              {!startDate && (
                                <FormFeedback>โปรดเลือกวันที่</FormFeedback>
                              )}
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                    </FormGroup>
                  </Col>
                </Row>
                <Button color="success" type="submit">
                  บันทึก
                </Button>
              </Form>
              <br />
              <SummaryTimeGroup orgID={orgInnerID} orgName={orgInnerName} />
            </CardBody>
          </Card>
        </FadeIn>
      )}
    </Fragment>
  );
}

export default TimeCommander;
